import { useTranslation } from 'react-i18next'
import { Icon } from '../Icon'

export interface StreakCardProps {
  count?: number | null
}

export function StreakCard({ count }: StreakCardProps) {
  const { t } = useTranslation()

  if (count == null || count === 0) {
    return (
      <div className="streak">
        <div className="streak__sub" style={{ fontSize: 13 }}>
          {t('lobby.streak.placeholder')}
        </div>
      </div>
    )
  }

  return (
    <div className="streak">
      <Icon name="flame" size={22} color="#E63946" />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="streak__num">{count}</div>
        <div className="streak__sub">
          {t('lobby.streak.count', { count })}
        </div>
      </div>
    </div>
  )
}
